import { render, staticRenderFns } from "./AppTabs.vue?vue&type=template&id=2ecaa754"
import script from "./AppTabs.vue?vue&type=script&lang=ts"
export * from "./AppTabs.vue?vue&type=script&lang=ts"
import style0 from "./AppTabs.vue?vue&type=style&index=0&id=2ecaa754&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UserEventVkBanner: require('/builds/project/wyffest/frontend/components/user/event/vk/UserEventVkBanner.vue').default,AppIcon: require('/builds/project/wyffest/frontend/components/app/AppIcon.vue').default})
